import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { AppNotification } from '@app/helpers';
import { AuthService, BrokerService, ClientService, ConductService, LocalStorageService, SurveyService } from '@app/services';
import { ConductListTableConfig } from '@app/views/conduct/conduct-list/conduct-list.table-config';

@Component({
  selector: 'app-client-add',
  templateUrl: './client-add.component.html',
  styleUrls: ['./client-add.component.scss']
})
export class ClientAddComponent implements OnInit {
  @Output() onDone: any = new EventEmitter();
  @Input() user: any;
  @Input() standalone: boolean = true;
  admin: any;
  @Input() clientId: string | null;
  addresses: any = []
  editingAddress: any = null;
  panelVisible: boolean = false;

  surveyConfig: any;

  brokerList: any[] = [];
  surveyList: any[] = [];
  conductList: any[] = [];

  currentUserRole: any;
  currentUser: any;

  constructor(
    private surveyService: SurveyService,
    private conductService: ConductService,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
    private brokerServie: BrokerService,
    private authService: AuthService) { }

  sideTabs: any = [{
    text: "Info"
  }, {
    //   text: "Peoples"
    // }, {
    text: "Locations"
  }, {
    text: "Surveys"
  }]

  getBrokerList() {
    this.brokerServie.list().subscribe({
      next: (res: any) => {
        let adminUser = this.currentUser?.brokerAdmin
        
        this.brokerList = res.data
        this.brokerList.push(adminUser)
        this.brokerList.forEach(o => {
          o.name = `${o.user.firstName} ${o.user.lastName}`
        })
        
        this.brokerList.sort((a: any, b: any) => {
          return a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        })
        // push admin user in list
      }
    })
  }


  ngOnInit(): void {
    this.currentUserRole = LocalStorageService.getUserRole()
    this.surveyConfig = ConductListTableConfig.configure();

    this.admin = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
    }
    console.log(this.clientId)
    this.getCurrentUser();
    if (this.clientId == null) {
      this.clientId = this.route.snapshot.queryParamMap.get('clientId');
    }
    if (this.clientId != null) {
      this.getClientDetail();
      this.getConductList();
    }
  }

  getClientDetail() {
    this.clientService.info(this.clientId).subscribe({
      next: (res: any) => {
        this.admin = res.data.user
        this.admin.exemptGST = res.data.exemptGST
        this.admin.exemptStampDuty = res.data.exemptStampDuty
        this.admin.legalName = res.data.legalName
        this.admin.ABN = res.data.ABN
        this.admin.tradingName = res.data.tradingName
        this.admin.website = res.data.website
        this.addresses = res.data.locations || []
        this.admin.broker = res.data.broker
      },
      error: () => { }
    })
  }

  getSurveyList() {
    this.surveyService.list().subscribe({
      next: (res: any) => {
        this.surveyList = res.data
      }
    })
  }

  onSaveHandler() {
    console.log(this.admin)
    if (this.clientId != null) {
      return this.clientService.update(this.clientId, {
        locations: this.addresses,
        firstName: this.admin.firstName,
        lastName: this.admin.lastName,
        phone: this.admin.phone,
        broker: this.admin.broker,
        isActive: this.admin.isActive,
        exemptGST: this.admin.exemptGST,
        exemptStampDuty: this.admin.exemptStampDuty,
        legalName: this.admin.legalName,
        ABN: this.admin.ABN,
        tradingName: this.admin.tradingName,
        website: this.admin.website,
        email: this.admin.email
      }).subscribe({
        next: (res: any) => {
          AppNotification.success("Saved");
        },
        error: (error: any) => {
          AppNotification.error(error?.error?.message ?? 'Error!');
        }
      })
    }
    return this.clientService.add({
      ...this.admin,
      locations: this.addresses
    }).subscribe({
      next: (res: any) => {
        this.onDone.emit(res.data)
        AppNotification.success('Saved!')
        this.router.navigate([APP_ROUTES.CLIENT])
      },
      error: (error: any) => {
        AppNotification.success(error?.error?.message ?? 'Error!')
      }
    })
  }

  onBrokerChanged() {

  }

  dataEventListener(e: any) {
    if (e.button?.eventName == 'back') {
      if(this.standalone == true) {
        this.router.navigate([APP_ROUTES.CLIENT])
      }
    }
    if (e.button?.eventName == 'save') {
      this.onSaveHandler()
    }
  }

  onLocation(location: any) {
    this.panelVisible = false;
    if (location == null) return
    if (this.editingAddress) {
      this.editingAddress.name = location.name;
      this.editingAddress.latitude = location.latitude;
      this.editingAddress.longitude = location.longitude;
      this.editingAddress.streetName = location.streetName;
      this.editingAddress.streetNumber = location.streetNumber;
      this.editingAddress.locality = location.locality;
      this.editingAddress.state = location.state;
      this.editingAddress.country = location.country;
      this.editingAddress.zipcode = location.zipcode;
    } else {
      this.addresses.push(location);
    }
  }

  onEditAddressClick(addr: any) {
    this.editingAddress = addr;
    this.panelVisible = true;
  }

  getConductList() {
    if (!this.clientId) return;
    this.conductService.list(null, this.clientId, true).subscribe({
      next: (res: any) => {
        this.conductList = res.data
        this.conductList.forEach((el: any) => {
          el.userName = `${el.client?.user.firstName || ""} ${el.client?.user.lastName || ""}`
        });
      }
    })
  }
  surveyClientSelectPopup: boolean = false;
  selectedSurvey: any;

  action(e: any) {
    if (e.button.eventName == "details") {
      this.router.navigate([
        APP_ROUTES.CONDUCT_DETAILS
      ], {
        queryParams: {
          conductId: e.data._id
        }
      });
    }
    if (e.button.eventName == "add") {
      this.surveyClientSelectPopup = true
      this.getSurveyList()
    }
    if (e.button.eventName == "copy") {
      this.cloneConduct(e.data);
      console.log(e);
    }
  }

  cloneConduct(sourceConduct: any) {
    return this.conductService.add({
      name: sourceConduct.name + " Copy",
      forms: sourceConduct.forms.map((o: any) => o._id),
      formState: sourceConduct.formState,
      survey: sourceConduct.survey._id,
      client: sourceConduct.client._id
    }).subscribe({
      next: (res: any) => {
        AppNotification.success('Cloned!')
        this.getConductList();
      },
      error: () => {
        AppNotification.error('Some error occured!')
      }
    })
  }

  proceedToConduct() {
    if (this.selectedSurvey == null || this.clientId == null) {
      return
    }
    this.router.navigate([
      APP_ROUTES.CONDUCT_DETAILS
    ], {
      queryParams: {
        surveyId: this.selectedSurvey,
        clientId: this.clientId
      }
    });
  }

  getCurrentUser() {
    this.authService.me().subscribe({
      next: (res: any) => {
        this.getBrokerList();
        this.currentUser = res.data
      }
    })
  }
}
